import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "antd/dist/reset.css";
import { Col, Row } from "antd";
import { Content } from "antd/es/layout/layout";

import _map from "lodash/map";
import ServiceTile from "../../ui/ServiceTile/ServiceTile";
import { services } from "./Homepage.helper";
import { useNavigate } from "react-router";
import { fetchServiceCategories } from "../../redux/actions/service";
import SpHighlight from "../../sp-components/SpHighlight/SpHighlight";
import withUserData from "../../HOC/withUserData";
import useSpModal from "../../sp-components/SpModal/SpModal";
import SpPageTransition from "../../sp-components/SpPagination/SpPagination";
import SpHomeHeroImage from "../../sp-components/SpHomeHeroImage/SpHomeHeroImage";
import { motion } from 'framer-motion';
import { resetTransactionFormData } from "../../redux/actions/transactions";
import SpDownloadButtons from "../../sp-components/SpDownloadButtons/SpDownloadButtons";
import SpAppPromptModal from "../../sp-components/SpAppPromptModal/SpAppPromptModal";


const WEB_AVAILABLE_SERVICES = ["buy electricity", "electricity"];


function Homepage({ isGuest = true, isLoggedIn }) {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { getStarted } = useSpModal();

  const { data: categories, loading: categoriesLoading, error: categoriesError } = useSelector(state => state.service.categories);

  const [value, setValue] = useState(null);
  const [serviceList, setServiceList] = useState(services);
  const [appPrompt, setAppPrompt] = useState({ open: false, serviceName: "" }); // 👈 new


  const wordExists = useCallback((key, service) => {
    const regex = new RegExp(key, "i");
    return regex.test(service);
  }, []);

  useEffect(() => {
    dispatch(fetchServiceCategories());
  }, []);

  useEffect(() => {
    if (value) {
      setServiceList(
        serviceList.filter(({ label }) => wordExists(value, label))
      );
      return;
    }
    if (value === "") {
      setServiceList(services);
    }
  }, [value, serviceList, wordExists]);
  const handleServiceClick = useCallback(
    (item, i) => {
      const { label, url, status } = item;

      // 👇 Inactive services are not clickable at all — do nothing
      if (status.toLowerCase() !== "active") {
        return;
      }

      // 👇 Active but not available on web — show download prompt
      const isAvailableOnWeb = WEB_AVAILABLE_SERVICES.some(
        (s) => label.toLowerCase().includes(s)
      );

      if (!isAvailableOnWeb) {
        setAppPrompt({ open: true, serviceName: label });
        return;
      }

      dispatch(resetTransactionFormData());

      if (isLoggedIn) {
        navigate(url);
        return;
      }

      getStarted({
        redirectTo: url,
      });
    },
    [dispatch, navigate, isGuest, isLoggedIn]
  );

  return (
    <SpPageTransition>
      <div className="homepage">
        <Row className="homepage__container">
          <Col className="homepage__container__row-one" span={12} lg={12} xs={24}>
            <Content>
              <h4 className="homepage__title">
                Pay your <SpHighlight>utility</SpHighlight> bills without stress
              </h4>

              <div className="line_break__lg" />
              <Row gutter={[20, 20]} className="service_tile__wrapper">
                {_map(
                  categories,
                  ({ name: label, image_url: icon, bg_color: bgColor, slug: url, status }, i) => (
                    <ServiceTile
                      key={i}
                      label={label}
                      icon={icon}
                      url={url}
                      bgColor={bgColor}
                      onClick={() => handleServiceClick({ label, url, status }, i)}
                      isActive={status.toLowerCase() === 'active'}
                    />
                  )
                )}
              </Row>

              {/* Download App Section */}
              <Row>
                <Col span={24}>
                  <SpDownloadButtons />
                </Col>
              </Row>

            </Content>
          </Col>
          <Col
            className="homepage__container__row-two"
            span={12}
            lg={12}
            sm={12}
            xs={24}
          >
            <Content className="homepage_content__img_wrapper">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.5 }}
              >
                <SpHomeHeroImage />
              </motion.div>
            </Content>
          </Col>

        </Row>

      </div>

      {/* 👇 App download prompt modal */}
      <SpAppPromptModal
        isOpen={appPrompt.open}
        serviceName={appPrompt.serviceName}
        onClose={() => setAppPrompt({ open: false, serviceName: "" })}
      />

    </SpPageTransition>
  );
}

export default withUserData(Homepage);